module.exports = __webpack_public_path__ + "img/streams.477cd1ac.svg";